module.exports = __webpack_public_path__ + "media/images/amenities_icons/vr_equipment-2952330eb40251c2908ded931ec91eca.svg";